export default __webpack_public_path__ + "static/media/0b44134d86a6cf02.32fb157373e79a8e3778a318a55fe995.svg";